import { render, staticRenderFns } from "./DeletedTabSidebar.vue?vue&type=template&id=262feec5&scoped=true&"
import script from "./DeletedTabSidebar.vue?vue&type=script&lang=js&"
export * from "./DeletedTabSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DeletedTabSidebar.vue?vue&type=style&index=0&id=262feec5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262feec5",
  null
  
)

export default component.exports